import defaultLayoutComponent from '~pages/nrw/layouts/NrwDefaultLayoutComponents.js'

let routeInfo = [
  {
    path: 'mySpace/myDashbrd',
    name: 'MyDashbrd',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_mySpace" */ '~pages/nrw/mypage/MyDashbrd.vue') }
    ),
    meta: {
      authorized: true,
      title: '나의학습'
    }
  },
  {
    path: 'mySpace/myLrnList',
    name: 'MyLrnList',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_mySpace" */ '~pages/nrw/mypage/MyLrnList.vue') }
    ),
    meta: {
      authorized: true,
      title: '학습목록'
    }
  },
  {
    path: 'mySpace/myChoiceList',
    name: 'MyChoiceList',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_mySpace" */ '~pages/nrw/mypage/MyChoiceList.vue') }
    ),
    meta: {
      authorized: true,
      title: '내가 찜한 학습'
    }
  },
  {
    path: 'mySpace/myCoupon',
    name: 'MyCoupon',
    props: true,
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_mySpace" */ '~pages/nrw/mypage/MyCoupon.vue') }
    ),
    meta: {
      authorized: true,
      title: '쿠폰관리'
    }
  },
  {
    path: 'mySpace/myQestnList',
    name: 'MyQestnList',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_mySpace" */ '~pages/nrw/mypage/MyQestnList.vue') }
    ),
    meta: {
      authorized: true,
      title: '문의내역'
    }
  },
  {
    path: 'mySpace/MyQestnListDetail',
    name: 'MyQestnListDetail',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_mySpace" */ '~pages/nrw/mypage/MyQestnListDetail.vue') }
    ),
    meta: {
      authorized: true,
      title: '문의내역 상세'
    }
  },
  {
    path: 'mySpace/myInfo',
    name: 'MyInfo',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_mySpace" */ '~pages/nrw/mypage/MyInfo.vue') }
    ),
    meta: {
      authorized: true,
      title: '나의정보'
    }
  },
  {
    path: 'mySpace/myInfoModify',
    name: 'MyInfoModify',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_mySpace" */ '~pages/nrw/mypage/MyInfoModify.vue') }
    ),
    meta: {
      authorized: true,
      title: '나의정보 수정'
    }
  },
  {
    path: 'mySpace/MyPwd',
    name: 'MyPwd',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_mySpace" */ '~pages/nrw/mypage/MyPwd.vue') }
    ),
    meta: {
      authorized: true,
      title: '비밀번호 변경'
    }
  },
  {
    path: 'mySpace/Withdrawal',
    name: 'Withdrawal',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_mySpace" */ '~pages/nrw/mypage/Withdrawal.vue') }
    ),
    meta: {
      authorized: true,
      title: '회원 탈퇴'
    }
  },
  { // 삭제해야되나? 일단 기획완료될때까지 기다려보자. 있어야되는거 같은데
    path: 'paymentHistory',
    name: 'MyPaymentHistory',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_mySpace" */ '~pages/nrw/mypage/PaymentHistory.vue') }
    ),
    meta: {
      authorized: true,
      title: '결제 내역'
    }
  },
  { // 삭제해야되나? 일단 기획완료될때까지 기다려보자. 있어야되는거 같은데
    path: 'paymentDetail',
    name: 'MyPaymentDetail',
    props: true,
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_mySpace" */ '~pages/nrw/mypage/PaymentDetail.vue') }
    ),
    meta: {
      authorized: true,
      title: '결제 내역 상세'
    }
  }
]

export default routeInfo



// WEBPACK FOOTER //
// ./src/config/router/nrw/child/mySpaceRouter.js